module.exports = __webpack_public_path__ + "static/media/ArboLegend.596a2db6.png";